/**
 * 기타 API — 어느 도메인에도 속하지 않는 것들 (환율 등).
 */

import { getJson } from './http';
import { TodayExchangeRateSchema, type TodayExchangeRate } from './schemas';

// ─── 환율 API (P9-UI Step 3d) ───────────────────────────────────────
/**
 * 오늘 USD→KRW 환율. 견적 모달의 환율 default 채움용.
 *
 * Source: frankfurter.app (EU 중앙은행 데이터). 실패 시 backend 가
 * fallback (1380) 반환 — UI 가 throw 받을 일 X.
 */
export type { TodayExchangeRate };

export async function fetchTodayExchangeRate(): Promise<TodayExchangeRate> {
  return getJson<TodayExchangeRate>('/api/admin/exchange-rate/today', { schema: TodayExchangeRateSchema });
}
